export default "__VITE_ASSET__7b18630a__"